import { useEffect, useState } from "react";

import { Skeleton } from "@mui/material";
import { Grid } from "@mui/material";

import MDBox from "components/MDBox";

import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import { isFiniteNumber } from "helpers/chartDataUtils";

import { getTotalEquipes } from "services/reports";

type Props = {
  gridLg?: 3 | 4;
};

export default function StatisticsCardTotalEquipes({ gridLg = 3 }: Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [valueTotalEquipes, setValueTotalEquipe] = useState<number | null>(
    null
  );

  useEffect(() => {
    (async () => {
      try {
        const { totalEquipes } = await getTotalEquipes();
        setValueTotalEquipe(
          isFiniteNumber(totalEquipes) ? totalEquipes : null
        );
      } catch {
        setValueTotalEquipe(null);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <Grid item xs={12} md={6} lg={gridLg}>
        <MDBox mb={1.5}>
          <Skeleton variant="rounded" height={120} />
        </MDBox>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} md={6} lg={gridLg}>
      <MDBox mb={1.5}>
        <ComplexStatisticsCard
          color="primary"
          icon="workspaces"
          title="Total Equipes"
          count={isFiniteNumber(valueTotalEquipes) ? valueTotalEquipes : "—"}
          percentage={{
            color: "success",
            amount: "",
            label: "Total Geral",
          }}
        />
      </MDBox>
    </Grid>
  );
}
